import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (username, password) => 
  api.post('/auth/login', { username, password });

export const verifyToken = () => 
  api.get('/auth/verify');

// Public Press Releases
export const getPressReleases = (category, tag) => {
  const params = {};
  if (category) params.category = category;
  if (tag) params.tag = tag;
  return api.get('/press-releases', { params });
};

export const getPressReleaseBySlug = (slug) => 
  api.get(`/press-releases/${slug}`);

export const getCategories = () => 
  api.get('/categories');

export const getTags = () => 
  api.get('/tags');

// Contact
export const submitContact = (data) => 
  api.post('/contact', data);

// Public PR Submission
export const submitPR = (data) => 
  api.post('/submit-pr', data);

// Admin Press Releases
export const getAllPressReleases = () => 
  api.get('/admin/press-releases');

export const createPressRelease = (data) => 
  api.post('/admin/press-releases', data);

export const updatePressRelease = (id, data) => 
  api.put(`/admin/press-releases/${id}`, data);

export const deletePressRelease = (id) => 
  api.delete(`/admin/press-releases/${id}`);

export const getAdminStats = () => 
  api.get('/admin/stats');

export default api;